import { getMaxRevData, getCampaign, getRatioOff } from "./dataHelper";
function GetMaxRevenue(area, users) {
  let proUsers = users.filter(
    (info) => info.objectid === area.properties.objectid && info.is_pro_user
  );

  return proUsers.length;
}
function GetCount(area, users) {
  let MaleCount = users.filter(
    (info) => info.objectid === area.properties.objectid && info.gender === "M"
  );
  let FemaleCount = users.filter(
    (info) => info.objectid === area.properties.objectid && info.gender === "F"
  );
  let ProCount = users.filter(
    (info) => info.objectid === area.properties.objectid && info.is_pro_user
  );

  return {
    MaleCount: MaleCount.length,
    FemaleCount: FemaleCount.length,
    ProCount: ProCount.length,
  };
}

async function MaxRevAreas(features, count) {
  let maxRevAreas = await getMaxRevData(count);
  let FilteredMaxrevAreas = maxRevAreas.map((info, index) => {
    return info.info;
  });
  return FilteredMaxrevAreas;
}

async function MoreCampaign() {
  let MaxCampaign = await getCampaign();
  let FilteredMaxCampaign = MaxCampaign.map((info, index) => {
    return info.info;
  });
  return FilteredMaxCampaign;
}

async function RatioOff() {
  let RatioOff = await getRatioOff();
  let FilteredRationOff = RatioOff.map((info, index) => {
    return info.info;
  });
  return FilteredRationOff;
}
export { GetMaxRevenue, MaxRevAreas, GetCount, MoreCampaign, RatioOff };
